import { useState } from "react";
import { authService } from "../../auth/services/authService";
import { validateRequiredFields } from "../../../../utils/helpers/validation/validateRequiredFields";

export const useSignIn = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    isUnverified: false,
    message: "",
    autoSent: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (status.message)
      setStatus((prev) => ({ ...prev, message: "", isUnverified: false }));
  };

  const handleSubmit = async () => {
    setStatus((prev) => ({ ...prev, loading: true, message: "" }));

    // Basic validation
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(formData.email)) {
      setStatus((prev) => ({
        ...prev,
        loading: false,
        message: "Please enter a valid email address.",
      }));
      return;
    }

    const isValidated = validateRequiredFields(formData, ["email", "password"]);
    if (!isValidated.isValid) {
      setStatus((prev) => ({
        ...prev,
        loading: false,
        message: "All fields are required.",
      }));
      return;
    }

    try {
      const res = await authService.signIn(formData.email, formData.password);
      const { isAuthenticated, isVerified, message } = res;

      if (isAuthenticated && isVerified) {
        const redirectTo = localStorage.getItem("redirectAfterLogin") || "/";
        localStorage.removeItem("redirectAfterLogin");
        window.location.href = redirectTo;
        return;
      }

      setStatus({
        loading: false,
        success: isAuthenticated,
        isUnverified: !isVerified && (res.needsVerification || isAuthenticated),
        message: message,
        autoSent: false,
      });
    } catch (err) {
      const errorData = err.response?.data || {};
      setStatus({
        loading: false,
        success: false,
        isUnverified:
          errorData.isVerified === false && errorData.status === "unverified",
        message: errorData.message || "Connection error. Please try again.",
        autoSent: !!errorData.autoSent,
      });
    }
  };

  const resendVerification = async () => {
    try {
      await authService.resendVerification(formData.email);
      setStatus((prev) => ({ ...prev, autoSent: true }));
    } catch {
      setStatus((prev) => ({ ...prev, message: "Failed to resend link." }));
    }
  };

  return { formData, status, handleChange, handleSubmit, resendVerification };
};
